import { Dispatch, SetStateAction } from 'react';
import { IUser, PDFModal, viewUserProfile } from '../common';
import {
  UserTabs,
  ViewUserProfile,
  ViewUserProfileDetails,
  UpdateUserProfileDetails,
} from '.';
import { styled } from '@mui/material';

export const render = ({
  user,
  currentTab,
  edit,
  setCurrentTab,
  setEdit,
}: {
  user: IUser;
  currentTab: number;
  edit: boolean;
  setCurrentTab: Dispatch<SetStateAction<number>>;
  setEdit: Dispatch<SetStateAction<boolean>>;
}) => (
  <Articl>
    <ViewUserProfile
      user={user}
      edit={edit}
      details={() =>
        viewUserProfile(user)(edit) ? (
          <ViewUserProfileDetails user={user} />
        ) : (
          <UpdateUserProfileDetails user={user} setEdit={setEdit} />
        )
      }
      setEdit={setEdit}
    />
    {viewUserProfile(user)(edit) ? (<div style={{ marginBottom: '5px', marginLeft: '0%' }}>
      <PDFModal
        fileUrl={'Create a Request.pdf'}
        fileLabel={'create request instructions'}
        fileDownload="create_req_instructions.pdf"
      />
    </div>) :
    <></>}
    <UserTabs
      user={user}
      currentTab={currentTab}
      setCurrentTab={setCurrentTab}
    />
  </Articl>
);

const Articl = styled('article')(({ theme }) => ({
  minHeight: '76vh',
  overflowY: 'auto',

  '& > *+*': {
    marginTop: '2rem !important',
  },
}));
